import React from "react";
var __jsx = React.createElement;
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Modal-styled card (header, scrollable body, footer) rendered in the middle section. */
export function ComposerShell(_ref) {
  var composerId = _ref.composerId,
    title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$wide = _ref.wide,
    wide = _ref$wide === void 0 ? false : _ref$wide,
    _ref$fullHeight = _ref.fullHeight,
    fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight,
    footer = _ref.footer,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var minimize = useComposerStore(function (state) {
    return state.minimize;
  });
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var minimizeLabel = t("minimize", {
    defaultValue: "Minimise"
  });
  var closeLabel = t("close", {
    defaultValue: "Close"
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "pointer-events-auto flex w-full flex-col rounded-sds-400 bg-sds-base-default ".concat(fullHeight ? "h-[85vh] max-h-[900px]" : "max-h-[85vh]", " ").concat(wide ? "max-w-5xl" : "max-w-2xl")
  }, /*#__PURE__*/React.createElement("header", {
    className: "flex items-start justify-between gap-3 px-5 pt-5 pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-col gap-1"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate text-style-heading-main text-sds-base-default"
  }, title), subtitle ? /*#__PURE__*/React.createElement("p", {
    className: "truncate text-style-body-small text-sds-base-secondary"
  }, subtitle) : null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0 items-center gap-1"
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "composer-minimize-".concat(composerId),
    "aria-label": minimizeLabel,
    title: minimizeLabel,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.COMPOSER_MINIMIZE, {
        composerId: composerId
      });
      minimize(composerId);
    },
    className: "flex h-8 w-8 items-center justify-center rounded-sds-200 text-sds-base-secondary transition-colors hover:bg-sds-base-secondary hover:text-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMinus,
    className: "h-4 w-4"
  })), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "composer-close-".concat(composerId),
    "aria-label": closeLabel,
    title: closeLabel,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.COMPOSER_CLOSE, {
        composerId: composerId
      });
      close(composerId);
    },
    className: "flex h-8 w-8 items-center justify-center rounded-sds-200 text-sds-base-secondary transition-colors hover:bg-sds-base-secondary hover:text-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    className: "h-4 w-4"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col overflow-y-auto scrollbar-sds px-5 pb-5"
  }, children), footer ? /*#__PURE__*/React.createElement("footer", {
    className: "mt-2 flex items-center justify-end gap-3 border-t border-sds-base-default px-5 py-4"
  }, footer) : null);
}